var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.233,
    height: 23.667,
    viewBox: "0 0 20.233 23.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-book",
    "data-name": "Icon feather-book",
    transform: "translate(-5 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42684",
    "data-name": "Path 42684",
    d: "M6,27.927A2.664,2.664,0,0,1,8.849,25.5H24.233",
    transform: "translate(0 -8.688)",
    fill: "none",
    stroke: "#e8b03e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42685",
    "data-name": "Path 42685",
    d: "M8.849,3H24.233V24.667H8.849A2.781,2.781,0,0,1,6,21.958V5.708A2.781,2.781,0,0,1,8.849,3Z",
    transform: "translate(0 -3)",
    fill: "none",
    stroke: "#e8b03e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon-book.74c669ebd3eebe0d1285da73dddc8e50.svg";
export { ForwardRef as ReactComponent };